

import React, { Component, Children } from 'react';
import cx from 'classnames';
import _memoize from 'lodash.memoize';
import _get from 'lodash.get';

import Tab from './Tab';
import '../styles/_tabs.scss';
















function getSelectedLineStyles(numberOfTabs, selectedTabIndex) {
  const calcTabWidth = 100 / numberOfTabs;

  return { left: `${calcTabWidth * selectedTabIndex}%`, width: `${calcTabWidth}%` };
}

function getSelectedLineClassNames(
isV2Design,
tabsPositionClassName,
activeBorderPosition,
className)
{
  const baseClassName = isV2Design ? 'tabs__selected-line-v2' : 'tabs__selected-line';
  const dynamicClassNames = {
    [`${tabsPositionClassName}__selected-line${isV2Design ? '-v2' : ''}`]: activeBorderPosition,
    [`${className}__selected-line${isV2Design ? '-v2' : ''}`]: className
  };

  return cx(baseClassName, dynamicClassNames);
}

export default class Tabs extends Component {
  onSelectTab = _memoize((selectedTabIndex) => () => {
    const { updateSelectedTabIndex } = this.props;

    this.setState({ selectedTabIndex });

    updateSelectedTabIndex({ selectedTabIndex });

    const content = document.querySelector('.tabs__tab-content');
    /* istanbul ignore next */
    if (!content) {return;}

    content.scrollTop = 0;
  });

  constructor(props) {
    super(props);

    this.state = {
      selectedTabIndex: props.selectedIndex || props.initialIndex || 0
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedIndex } = this.props;

    if (selectedIndex !== undefined && selectedIndex !== prevProps.selectedIndex) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ selectedTabIndex: selectedIndex });
    }
  }


  render() {
    const { children, className = '', fixedIndex, activeBorderPosition = 'top', isV2Design = false } = this.props;
    const tabs = Children.toArray(children);
    const { selectedTabIndex } = this.state;
    const activeTabIndex = typeof fixedIndex === 'number' ? fixedIndex : selectedTabIndex;
    const tabsPositionClassName = `tabs-${activeBorderPosition}`;

    return (
      <div className={cx('tabs', { [tabsPositionClassName]: activeBorderPosition }, className)}>
        <div
          className={getSelectedLineClassNames(
            isV2Design,
            tabsPositionClassName,
            activeBorderPosition,
            className
          )}
          style={getSelectedLineStyles(tabs.length, activeTabIndex)} />

        <ol className={cx('tabs__list', { [`${className}__list`]: className })}>
          {tabs.map((tab, index) =>
          <Tab
            key={_get(tab, 'props.title')}
            isSelected={index === activeTabIndex}
            title={_get(tab, 'props.title')}
            onClick={this.onSelectTab(index)}
            className={className}
            activeBorderPosition={activeBorderPosition}
            isV2Design={isV2Design} />

          )}
        </ol>
        <div className={cx('tabs__tab-content', { [`${tabsPositionClassName}__tab-content`]: activeBorderPosition, [`${className}__tab-content`]: className })}>
          {tabs[selectedTabIndex]}
        </div>
      </div>);

  }
}